/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import * as yup from 'yup';
import TagList2 from 'components/TagList2';
import { Row, Col } from "components/Grid";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { PlaceHolder, TagInput, ButtonContent, Title, RadioContainer, BorderSwitch } from "./styles";
import { LostCancelButton, TextEditorBox } from 'components/index';
import StepNavigation from "components/StepNavigation/index";
import HasPermission from "components/HasPermission/index";
import DragZoneUpload from 'components/DragZoneUpload';
import { RadioButton } from "components/Form/Radio/index";
import { Label } from 'components/Form';
import Switch from 'react-switch';
import { cloneDeep } from 'lodash';
import {onValidationError} from '../../../../utils/src/validationForm';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer
} from '@fitinsur/services/QuestionnaireAnswerService';
import {
  useUpdateOperations
} from '@fitinsur/services/OperationService';

const SECTIONS = {
  ENDORSEMENT_EDIT: { name: 'ENDORSEMENT_EDIT', isMultiple: false, isRisk: false }
};

export default function ApprovalEndorsementPackAdjustmentsCorrections(props) {
  const [summary, setSummary] = useState({});
  const [attachments, setAttachments] = useState([]);
  const authContext = useContext(GlobalAuthContext);
  const [isApproved, setIsApproved] = useState(false);
  const [isBound, setIsBound] = useState(false);
  const [idDomainDocument, setIdDomainDocument] = useState(null);
  const [idDomainStatusDocument, setIdDomainStatusDocument] = useState(null);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [operationMetadata, setOperationMetadata] = useState(null);
  const [isDisable, setIsDisable] = useState(true);
  const [generateSignatureEndorsementsLoading, setGenerateSignatureEndorsementsLoading] = useState(false);

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const isClient = authContext.enumProfile == 1 ? true : false;

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useUpdateOperationsData,
    loading: useUpdateOperationsLoading,
    error: useUpdateOperationsError,
    status: useUpdateOperationsStatus,
    request: useUpdateOperationsRequest,
  } = useUpdateOperations(props.match.params.idOperation);

  useEffect(() => {
    if (
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useUpdateOperationsLoading ||
      generateSignatureEndorsementsLoading
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useUpdateOperationsLoading,
    generateSignatureEndorsementsLoading,
  ]);

  useEffect(() => {
    buildValidation();

    const contractDocuments = questionnaire.find((qst) => qst.idQuestion === 1867)?.answer || [];

    if(contractDocuments.length > 0) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [questionnaire]);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);
  
  useEffect(() => {
    if (
      useSaveQuestionnaireAnswerStatus === 200 && 
      useUpdateOperationsStatus === 200
    ) {
      generateSignatureEndorsements();
      
    } else if (useSaveQuestionnaireAnswerStatus === 400) {
      useSaveQuestionnaireAnswerError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    } else if (useUpdateOperationsStatus === 400) {
      useUpdateOperationsError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    }
  }, [useSaveQuestionnaireAnswerStatus, useUpdateOperationsStatus]);

  const handleQuestionnaire = (data) => {
    let questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
    ];

    const filteredQuestions = questionnaire.filter(qst => 
      qst.idQuestion === 1820
      || qst.idQuestion === 1867
      || qst.idQuestion === 1870
      || qst.idQuestion === 1871
    );

    for(const question of filteredQuestions) {
      if(question.idQuestion === 1820) {
        if (!question?.answer && operationMetadata?.endorsementReference) {
          question.answer = operationMetadata?.endorsementReference;
        }
      }
      if(question.idQuestion === 1867) {
        question.answerOptions.forEach((option) => {
          if(option.idAnswerOption === 7524) {
            option.behaviorObject = {
              isResultDomainDocument: true,
              resultIdDomainDocument: idDomainDocument,
              resultIdDomainStatusDocument: idDomainStatusDocument
            }
          }
        })
      }
      if(question.idQuestion === 1870) {
        question.visibleQuestion = false
        question.answer = 'No'
        question.answerJson = 'No'
        question.idAnswerOption = 7529
      }
    }

    setQuestionnaire(filteredQuestions);
  }

  function handleSummary() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        loading.stop();
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        loading.stop();
        console.error('fitPostSummary - Error:', error);
      });
  };

  const validationSchema = yup.object().shape({});

  async function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        useGetQuestionnairesAnswersRequest();
        setOperationMetadata(response.metadata);
        setIdDomainDocument(response.idDomainDocument);
        setIdDomainStatusDocument(response.idDomainStatusDocument);

        let documentDomain= null; 
        let documentDomainStatus = null;
        if (response.idDomain === 398) {
          documentDomain = 399;
          documentDomainStatus = 118;
        } else if (response.idDomain === 400) {
          documentDomain = 401;
          documentDomainStatus = 143;
        } else if (response.idDomain === 254) {
          documentDomain = 450;
          documentDomainStatus = 180;
        } else if (response.isMarketChanges || response.idDomain === 410) {
          documentDomain = 453;
          documentDomainStatus = 205;
        } else if (response.idDomain === 395) {
          documentDomain = 397;
          documentDomainStatus = 100;
        } else if (response.idDomain === 253) {
          documentDomain = 493;
          documentDomainStatus = 270;
        }
        setIdDomainDocument(documentDomain);
        setIdDomainStatusDocument(documentDomainStatus);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  const handleSaveQuestionnaireAnswer = (onlyQuestions) => {
    const body = { questionnaireAnswers: cloneDeep(questionnaire) };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map(group => {
          if (group?.length) {
            const rootQuestion = group.find(question => !question.idQuestionRoot);
            const childrenQuestions = group.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...group];
            }
          }
        })
      }
    }

    for (const question of body.questionnaireAnswers) {
      if (
        (
          question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer
      ) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      } else if (question.idQuestion === 1820 && question.answer) {
        question.answer = question.answer.padStart(3, '0');
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }

  const buildValidation = () => {
    const validationSchema = {};

    const questionnaire = handleSaveQuestionnaireAnswer(true);
    
    for (const question of questionnaire) {
      if (!question.key) continue;
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
          return question.answer === 0 ? true : !!question.answer;
        }) : yup.string().notRequired();
    }

    return yup.object().shape(validationSchema);
  }

  const validateEndorsementContract = () => {      
    const endorsementContractQst = questionnaire.find((question) => question.idQuestion === 1867);
    
    const { answer } = endorsementContractQst;

    if(answer.length) {
      if(!answer.some((file) => file.documentType.idAnswerOption === '7524')) 
        throw new Error('Please, add the endorsement contract')
    }
  }

  const handleSubmit = (values) => {
    buildValidation()
      .validate(values, { abortEarly: false })
      .then(() => {
        validateEndorsementContract()
        handleSaveQuestionnaireAnswer()

        setGenerateSignatureEndorsementsLoading(true);

        const endorsementRefAnswer = questionnaire.find(
          qst => qst.idQuestion === 1820
        )?.answer;

        useUpdateOperationsRequest({
          operationMetadata: {
            ...operationMetadata,
            endorsementReference: endorsementRefAnswer.padStart(3, '0')
          }
        })
      })
      .catch((e) => {
        if(e.message === 'Please, add the endorsement contract') {
          mc.error(e.message)
        } else {
          onValidationError(e, mc, formik, questionnaire, [])
        }

        loading.stop();
      })  
  }
  
  function handleGetFiles() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetDocumentsEndorsementContracts(props.match.params.idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        
        const files = response.ret_value;
        let aux = [];

        files.forEach(file => {
          let obj = {
            dsTypeDocument: "Attachment",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          };
          aux.push(obj);
        });
        setAttachments(aux);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  }

  async function generateSignatureEndorsements(showInsuredStamps) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    let body = {
      showInsuredStamps: showInsuredStamps == true || showInsuredStamps == false ? showInsuredStamps : formik?.current?.values?.showInsuredStamps
    };

    fitinsur.generateSignatureEndorsements(props.match.params.idOperation, body)
      .then(data => data.json())
      .then(response => {
        history.push(`/broking/adjustments-and-corrections/${props.match.params.idOperation}`);
        loading.stop();
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${generateSignatureEndorsements.name}\n` + error);
      });
  }

  function handleRmvAttach(index) {
    loading.start();
    setAttachments(attachments.filter(tag => attachments.indexOf(tag) !== index));

    const idDocument = attachments[index].idDocument

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestDeleteSchedulleAssumptionsCorrections(props.match.params.idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        loading.stop();
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        } else {
          handleGetFiles();
        }
      }).catch(() => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleDocument() {
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestGetDocumentMetadata(props.match.params.idOperation)
      .then(response => response.json())      
      .catch((error) => {
        mc.error("Error\n" + error);
      });
  }

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
    };


    if (isClient === true) {
      history.push('/list');
      return;
    }

    handleSummary();
    handleGetFiles();
    handleDocument();
    getOperationInfo();
  }, []);

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={ summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation}/>
      <BrokingSummary data={summary} />

      <ContentCard title={'ENDORSEMENT ADJUSTMENTS & CORRECTIONS - EDIT ENDORSEMENT CONTRACT'} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{}}
          onSubmit={(values) => handleSubmit(values)}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          validationSchema={validationSchema}
        >
          {({touched, values, setFieldValue, setFieldError, errors}) => {
            return (
              <Form>                
                <FormSection
                  sectionName="ENDORSEMENT_EDIT"
                  setQuestionnaire={setQuestionnaire}
                  values={values}
                  questionnaire={questionnaire}
                  setFieldValue={setFieldValue}
                  formikRef={formik}
                  idOperation={props.match?.params?.idOperation}
                  errors={errors}
                  setFieldError={setFieldError}
                  ignoreModality={true}
                />

                <Row>
                  <Col md={6} style={{ marginTop: "15px" }}>
                    <TagList2
                      tags={attachments}
                      disableType
                      hideTrash={false}
                      removeTag={(index) => handleRmvAttach(index)}
                    />
                  </Col>
                </Row>

                <ButtonContainer>
                  <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                  <HasPermission permission={!isBound}>
                    <ButtonContent>
                      {!isApproved && (
                        <>
                          <div style={{ marginTop: "5px" }}>
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                          <Button
                            style={{ marginLeft: "10px", marginTop: "5px" }}
                            primary
                            type="submit"
                            id="btnSubmit"
                            disabled={isDisable}
                          >
                            GENERATE PACK
                          </Button>
                        </>
                      )}
                    </ButtonContent>
                  </HasPermission>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
